// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".control-label[data-v-167ad618] {\n  font-size: 0.675rem;\n}\n[data-v-167ad618] .v-list-item__action {\n  -webkit-transform: scale(0.6) !important;\n          transform: scale(0.6) !important;\n  margin-right: 10px !important;\n}", ""]);
// Exports
module.exports = exports;
